<template>  
<div>
    <b-container v-if="loading" class="text-center">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
    </b-container>
    <b-container v-if="!loading" class="conta"> 
        <b-row>
            <b-col> 
                <p class="h2">
                    Solicitud de Cambio de Domicilio Electoral
                </p> 
                 
            </b-col>
        </b-row> 

        <div v-if="registro" class="item1">
            <b-row>
                <b-col> <legend>1.- DATOS DEL SOLICITANTE</legend>   </b-col>  
            </b-row>
            <hr class="mt-0 mb-0">
            <b-row>
               <b-col  sm="2">
                      <strong>RUN</strong> 
                </b-col>   
               <b-col>
                      <strong>: {{ formatRun()  }}</strong> 
                </b-col>   
            </b-row>
            <b-row>
               <b-col  sm="2">
                      <strong>NOMBRE</strong> 
                </b-col>   
               <b-col  >
                      <strong>: {{ formatNombre() }}</strong> 
                </b-col>   
            </b-row>
            <b-row>
                <b-col> <legend>DOMICILIO ELECTORAL ACTUAL</legend>   </b-col>  
            </b-row>
            <hr class="mt-0 mb-0">
            <b-row>
               <b-col  sm="2">
                      <strong>PAÍS</strong> 
                </b-col>   
               <b-col>
                      <strong>: {{ registro.glosa_pais }}</strong> 
                </b-col>   
            </b-row>
            <b-row>
               <b-col  sm="2">
                      <strong>DOMICILIO</strong> 
                </b-col>   
               <b-col  >
                      <strong>: {{ formatDireccion() }}</strong> 
        
                </b-col>   
            </b-row>

        </div> 
        <DomicilioElectoral 
            v-bind:otrasValidaciones="false"
            v-on:sendToForm="sendToForm">
        </DomicilioElectoral>    

     
       
    </b-container> 
</div> 
</template>

 
 
<script>  
 
import axios from 'axios'  
import Swal from 'sweetalert2'  
import { format }  from 'rut.js'
import { mapState, mapActions } from "vuex"
import DomicilioElectoral from './partials/DomicilioElectoral'
import router from '../router'

 
 

 const computed = {
    ...mapState('registro', ['registro']), 
    ...mapState('domicilio', [
        'formChileUrbano',
        'formChileRural',
        'formExtranjero',
        'formComun',
        'ubicacion',
        `paises`,
        `regiones`,
        `territorios`,
        `circunscripciones`,
        `ciudades`,
        `comunas`,
        ]), 
} 
 

export default {
    name: "Solicitar",
    components: {  
        DomicilioElectoral 
    },  
    computed,
    data: function () {
    return { 
            loading : true, 
        }
    }, 
    async mounted()
    {  
        
        this.loading = false

    
    },
    methods: { 
        ...mapActions('solicitud', ['setCdomicilio', 'setFolio']),

        formatDireccion()
        {
            let domicilio = ''

            if(this.registro.calle) domicilio = `${ this.registro.calle}`
            if(this.registro.numero) domicilio += ` ${ this.registro.numero}`
            if(this.registro.resto) domicilio += ` ${ this.registro.resto}`
            if(this.registro.nombre_comuna) domicilio += `, ${ this.registro.nombre_comuna}`
            if(this.registro.nombre_region) domicilio += `, ${ this.registro.nombre_region}`

            domicilio+= ` CIRCUNSCRIPCIÓN : ${ this.registro.nombre_circuns }`

            return domicilio

        },
        formatNombre()
        {
            if(!this.registro) 
             return 'No existe usuario '


            let nombre = ``

            if(this.registro.paterno) nombre += this.registro.paterno
            if(this.registro.materno) nombre += ' '+ this.registro.materno
            if(this.registro.nombre) nombre += ' '+ this.registro.nombre

            return nombre

        },
        formatRun()
        { 
            if(!this.registro) 
             return 'No existe usuario '

            return format(`${this.registro.cedula}-${this.registro.dv}`)

        },
 
 
   
        async sendToForm()
        { 
            this.loading = true

            try {

             
                const url = `${ process.env.VUE_APP_API_URL }/setsolicitud`
                const payload = {}
                // comunes
                payload.email = this.formComun.email 
                payload.telefono = this.formComun.telefono 
                payload.incorporacion = true
                
 
                payload.calle = null 
                payload.numero = null 
                payload.resto = null
                payload.origen = null 
                payload.cod_ubicacion = null 
                payload.cod_pais = null 
                payload.cod_region = null 
                payload.cod_comuna = null 
                payload.cod_circunscripcion = null
                payload.localidad = null
                payload.cod_consulado = null
                payload.codigopostal = null  
                payload.nombres = null  
                payload.paterno = null  
                payload.materno  = null  
                payload.paisnacimiento = null  

                if(this.ubicacion == 'chile-urbano')
                {
                    payload.cod_pais = 'CL' 
                    payload.pais = 'CHILE' 
                    payload.cod_region = this.formChileUrbano.region 
                    payload.cod_comuna = this.formChileUrbano.comuna 
                    payload.localidad = this.formChileUrbano.villa_poblacion
                    payload.calle = this.formChileUrbano.calle
                    payload.numero = this.formChileUrbano.numero 
                    payload.resto = this.formChileUrbano.block_depto
                    payload.notificacion_correo = this.formChileUrbano.notificacion_correo
                    payload.region = (this.regiones.find(reg=> reg.cod_region == payload.cod_region)).region 
                    payload.comuna = (this.comunas.find(com=> com.cod_comuna == payload.cod_comuna)).comuna 
                    payload.cod_ubicacion = 'U'
                    payload.posicion =  this.formChileUrbano.posicion 
                }
                if(this.ubicacion == 'chile-rural')
                {
                    payload.cod_pais = 'CL' 
                    payload.pais = 'CHILE' 
                    payload.cod_region = this.formChileRural.region
                    payload.cod_comuna = this.formChileRural.comuna 
                    payload.localidad = this.formChileRural.localidad
                    payload.calle = this.formChileRural.calle
                    payload.numero = this.formChileRural.numero  
                    payload.notificacion_correo = this.formChileUrbano.notificacion_correo
                    payload.region = (this.regiones.find(reg=> reg.cod_region == payload.cod_region)).region  
                    payload.comuna = (this.comunas.find(com=> com.cod_comuna == payload.cod_comuna)).comuna 
                    payload.cod_ubicacion = 'R' 
                }

                if(this.ubicacion == 'extranjero')
                {
                    
                    payload.cod_pais = this.formExtranjero.pais 
                    payload.pais = (this.paises.find(pa=> pa.cod_pais == payload.cod_pais)).pais                  
                    payload.cod_region = this.formExtranjero.division_territorial 
                    payload.region = (this.territorios.find(reg=> reg.cod_region == payload.cod_region)).region  
                    payload.cod_comuna = this.formExtranjero.ciudad 
                    payload.comuna = (this.ciudades.find(com=> com.cod_comuna == payload.cod_comuna)).comuna 
                    payload.calle = this.formExtranjero.calle
                    payload.numero = this.formExtranjero.numero  
                    payload.codigopostal = this.formExtranjero.codigo_postal 
                    payload.cod_circunscripcion = this.formExtranjero.circunscripcion
                    payload.circunscripcion = (this.circunscripciones.find(cir=> cir.cod_circunscripcion == payload.cod_circunscripcion)).circunscripcion 
                    payload.notificacion_correo = true
                    payload.cod_ubicacion = 'E'  
                    payload.posicion =  this.formExtranjero.posicion 
                }
 
                

                const { data: { folio, error} } = await  axios.post(url, payload)
  
                
                if(error) throw error  
 

                this.setFolio(folio)

                this.setCdomicilio(true)

            
                router.push({path: '/success'})
                

            } catch (error) {
                this.loading = false
                console.error("Error al enviar el formulario:: ", error)
                return Swal.fire({
                    icon: 'error',
                    type: 'error',
                    text: error,
                    confirmButtonText: 'Aceptar',
                })
            } 
        } 
    }
}
</script>

<style>
</style>
